import { createRouter, createWebHistory } from "vue-router";

import ProjectManagerPage from "./views/project/ProjectDataTable.vue";
import ProjectCompletenessReport from "./views/report/ProjectCompletenessReport.vue";
import ProjectUnImportReport from "./views/report/ProjectUnImportReport.vue";
import ProjectStatusReport from "./views/report/ProjectStatusReport.vue";
import UserSettingPage from "./views/user/UserSettingPage.vue";
import AboutPage from "./views/AboutPage.vue";

import UnAuthHome from "./views/UnAuthHome.vue";
import LoginHome from "./views/LoginHome.vue";

import DashboardLayout from "./layouts/DashboardLayout.vue";
import DefaultLayout from "./layouts/DefaultLayout.vue";

import common from "./common.js";
import config from "./config.js";

const routes = [
  {
    path: "/home",
    name: "Dashboard",
    component: DashboardLayout,
    beforeEnter: function (to, from, next) {
      if (process.env.NODE_ENV === 'local') {
        next();
        return ;
      }
      common.authToken(to.query.otp, 
        () => {
          common.getRequest(config.mgmtUserEntity, (response) => {
            common.saveAuthorizedQuestTypes(response.data.authorizedQuestTypes);
            common.saveQueryDuration(response.data.userConfig.queryDuration);
            next();
          }, () => next());
        }, () => next("/"));
    },
    children: [{
      path: "/home",
      name: "ProjectManager",
      component: ProjectManagerPage
    }, {
      path: "/home",
      name: "ProjectCompletenessReport",
      component: ProjectCompletenessReport
    }, {
      path: "/home",
      name: "ProjectUnImportReport",
      component: ProjectUnImportReport
    }, {
      path: "/home",
      name: "ProjectStatusReport",
      component: ProjectStatusReport
    }, {
      path: "/home",
      name: "UserSetting",
      component: UserSettingPage
    }, {
      path: "/home",
      name: "About",
      component: AboutPage,
    }]
  }, {
    path: "/",
    name: "Public",
    component: DefaultLayout,
    children: [{
        path: "/",
        component: LoginHome,
        beforeEnter: function (to, from, next) {
          if (process.env.NODE_ENV === 'local') {
            next();
            return ;
          }
          common.authToken(to.query.otp, 
            () => next("/home"), 
            () => next());
        }
      }, {
        path: "/unauthorize",
        component: UnAuthHome,
      }]
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes: routes
});

export default router;
